import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";

export default function VideoModal({ src, title, open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl bg-[#0B0F14] border-white/10 rounded-none p-0 gap-0 [&>button]:hidden overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <DialogTitle className="font-mono-tech text-[11px] tracking-[0.2em] text-[#FF5E1E] uppercase">▶ {title}</DialogTitle>
          <button data-testid="video-modal-close" onClick={onClose} className="text-[#8FA3B8] hover:text-white p-1"><X size={18} /></button>
        </div>
        {src && (
          <video key={src} data-testid="training-video" src={src} controls autoPlay muted playsInline className="w-full aspect-video bg-black" />
        )}
        <div className="px-4 py-3 text-[11px] text-[#8FA3B8] font-mono-tech tracking-wide">TRAINING PREVIEW · REPRESENTATIVE FOOTAGE</div>
      </DialogContent>
    </Dialog>
  );
}
